const START_FNA_FLOW = 'START_FNA_FLOW'
const START_QQ_FLOW = 'START_QQ_FLOW'
export const ACTIONS = {
  START_FNA_FLOW,
  START_QQ_FLOW,
}

export default ACTIONS
